export const REACTIVATION_FORM_BASE_PATH = 'talent_reactivation';

export default function isReactivationFlow(basePath) {
  return basePath.includes(REACTIVATION_FORM_BASE_PATH);
}
